import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['class', 'toggler', 'toggle'];
  connect() {
    // this.recover();
  }

  toggle() {
    this.toggleTargets.forEach((toggleTarget) => toggleTarget.classList.toggle('hidden'));
    this.classTargets.forEach((classTarget) => this.toggleClass(classTarget));
  }

  toggleClass(element) {
    if (element.className === '') {
      this.recover(element);
    } else {
      this.remove(element);
    }
  }

  remove(element) {
    const className = element.className;
    element.setAttribute('data-class-toggler-class', className);
    element.className = '';
  }

  recover(element) {
    const className = element.getAttribute('data-class-toggler-class');
    element.className = className;
  }
}
